import { CanDeactivateFn } from '@angular/router';
import { NoteCreatorComponent } from '../note-detailed/creator/note-creator.component';

export const confirmNoteDeactivateGuard: CanDeactivateFn<NoteCreatorComponent> = (
  component: NoteCreatorComponent,
  currentRoute,
  currentState,
  nextState
) => {
    console.log('confirmNoteDeactivateGuard');
  if (component.checkForNoteChanges()) {
    component.showDeactivateNoteModal(nextState);
    return false;
  }
  return true;
};
